import script from "./IslandBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./IslandBadge.vue?vue&type=script&lang=ts&setup=true"

import "./IslandBadge.vue?vue&type=style&index=0&id=35fc6b3a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35fc6b3a"]])

export default __exports__